import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { Sgke390dDialogComponent } from '../../components/sgke390d-dialog/sgke390d-dialog.component';
import { Sgke390dDialogData } from '../../models/sgke390d-dialog-data';

@Component({
  selector: 'app-sgke390d',
  templateUrl: './sgke390d.component.html',
  styleUrl: './sgke390d.component.scss'
})
export class Sgke390dComponent {

  /** MatDialog参照 */
  ref: MatDialogRef<Sgke390dDialogComponent, any>;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** ダイアログデータ */
  public dialogData: Sgke390dDialogData = {
    /** 供給地点特定番号 */
    suppntSpno: '123456789012345',
    /** 供給停止再開履歴番号 */
    supplystopresumptionRrkno: '12345',
    /** 使用者名 */
    visitormei: '西部　太郎（サイブ　タロウ）',
  }

  /**
   * コンストラクタ
   * @param {MatDialog} dialog
   * @memberof Sgke390dComponent
   */
  constructor(
    public dialog: MatDialog,
  ) {
  }

  /**
   * 初期処理
   * @memberof Sgke390dComponent
   */
  ngOnInit(): void {
  }

  /**
   * 購読解除
   * @memberof Sgke390dComponent
   */
  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 指針入力ボタン押下時処理
   *
   * @memberof Sgke390dComponent
   */
  public onClickShishinBtn(): void {


    // ダイアログオープン
    this.ref = this.dialog.open(Sgke390dDialogComponent, {
      height: '910px',
      width: '1150px',
      disableClose: true,
      data: this.dialogData,
    });

    // クローズ時の処理
    // this.ref.afterClosed()
    //   .pipe(takeUntil(this.onDestroy$))
    //   .subscribe(result => {
    //     // 表示するためのコンテナを取得
    //     const targetContainer = document.getElementById('target-container');
    //     targetContainer ? targetContainer.innerHTML = '' : null;
    //     // 各項目をpタグに変換
    //     for (const key in result) {
    //       if (result.hasOwnProperty(key)) {
    //         const p = document.createElement('p');
    //         p.textContent = `${key}: ${result[key]}`;
    //         targetContainer.appendChild(p);
    //       }
    //     }
    //   });
  }

}
